export default "/assets/gluten-free.svg";